import {Component, ElementRef, OnInit, Renderer2} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppService} from '../../services/app.service';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {ProductService} from '../../services/product.service';
import {Title} from '@angular/platform-browser';
import * as $ from 'jquery';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
  selector: 'app-search-exclusive',
  templateUrl: './search-exclusive.component.html',
  styleUrls: ['./search-exclusive.component.css']
})
export class SearchExclusiveComponent implements OnInit {


  selectedCity = '';
  selectedKeyword = '';
  responseReceived = false;
  products = [];
  category: any;
  merchant: any;
  city: any;
  response: any;
  pages = [];

  // device identification
  public deviceInfo;
  public isMobile;
  public isDesktopDevice;

  constructor(
    private http: HttpClient,
    public appService: AppService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private productService: ProductService,
    private titleService: Title,
    private renderer: Renderer2,
    private el: ElementRef,
    private deviceService: DeviceDetectorService,
  ) {
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.selectedCity = params.get('city');
      this.selectedKeyword = params.get('keyword');
    });

    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    this.isDesktopDevice = this.deviceService.isDesktop();

    this.titleService.setTitle('Things2do - Search Exclusives');

    this.loadExperiences();
  }

  loadExperiences(page: number = 1): void {
    this.products = [];
    this.productService.searchExclusive(this.selectedCity, this.selectedKeyword).subscribe(response => {
        if (response) {
          this.products = response.data.data;
          this.response = response.data;
          this.responseReceived = true;
          this.pages = [];
          for (var i = 1; i <= this.response.last_page; i++) {
            this.pages.push(i);
          }

        }
      },
      error => {
        console.error('There was an error!', error);
      });
  }

  goToPage($page): void {
    if ($page <= 0) {
      $page = 1;
    }
    if ($page > this.response.last_page) {
      $page = this.response.last_page;
    }
    if ($page !== this.response.current_page) {
      this.loadExperiences($page);
    }
  }


  showProductDetail(product): void {
    this.router.navigate(['c/' + product.city.name.toLowerCase().toString() + '/' + product.slug]);
  }

  public onVideoIntersection({target, visible}: { target: any; visible: boolean }): void {

    if (!this.isMobile) {
      return;
    }

    this.renderer.addClass(target, visible ? 'active' : 'inactive');
    this.renderer.removeClass(target, visible ? 'inactive' : 'active');

    // this.renderer.setProperty(target, 'play', true);
    // target.nativeElement.play();
    if (visible) {
      target.play();
    } else {
      target.pause();
    }
  }

  playVideo(e): void {
    e.play();
  }

  pauseVideo(e): void {
    e.pause();
  }


  videoVolumeControl(e): void {
    let x = $(e).attr('src');
    (x == 'assets/images/icons/sound.png') ? $(e).attr('src', 'assets/images/icons/mute.png') : $(e).attr('src', 'assets/images/icons/sound.png');
    (x == 'assets/images/icons/sound.png') ? $(e).parents('.image').find('video').prop('muted', true) : $(e).parents('.image').find('video').prop('muted', false);
  }


}
